var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"registration-page bg-gray-2 d-flex justify-content-center py-5"},[_c('div',{staticClass:"bg-white p-4 login-card rounded"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }